import React from 'react';
import { useLocation } from 'react-router';
import { LoadingSpinner } from '../components/shared/LoadingSpinner';

export const ExitIframe: React.FC = (props) => {
    // const appBridge = useAppBridge();
    const { search } = useLocation();

    if (search) {
        const params = new URLSearchParams(search);
        const redirectUri = params.get('redirectUri') as string;
        if (redirectUri) {
            const url = new URL(decodeURIComponent(redirectUri));

            if (url.hostname === location.hostname) {
                open(decodeURIComponent(redirectUri), '_top');
            }
        }
    }

    // return <Page />;
    return <LoadingSpinner />;
};
